var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpsideDownPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.002,
    height: 12.999,
    viewBox: "0 0 5.002 12.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_86",
    "data-name": "Union 86",
    d: "M2,0V8.047a2.5,2.5,0,1,0,1,0V0Z",
    fill: "#0d6877"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsideDownPin);
export default __webpack_public_path__ + "static/media/upsideDownPin.ff88f725b22730226e65438088348520.svg";
export { ForwardRef as ReactComponent };